/**
 * The five category families, their order, and their colours.
 *
 * Its own module rather than living beside the chart: the chart, the legend and
 * the breakdown table all read it, and a component file that also exports
 * constants breaks fast refresh. One definition means the swatch in the table
 * can never disagree with the segment in the stack.
 *
 * The order matches `CATEGORY_FAMILIES` in the report's transform.py, which is
 * also the order the server sorts by -- so a stack reads the same top-to-bottom
 * as the rows underneath it.
 */

export interface Family {
  key: string
  color: string
}

export const FAMILIES: readonly Family[] = [
  { key: 'Packaging component', color: '#2a78d6' },
  { key: 'Product quality', color: '#4d9c1a' },
  { key: 'Handling & containment', color: '#fab219' },
  { key: 'Documentation', color: '#8b5cf6' },
  { key: 'Unspecified', color: '#98a2b3' },
  // Its own colour rather than folded into "Unspecified": a CAR the categorizer
  // has not reached is a different thing from one whose complaint text does not
  // say what was wrong, and hiding the first inside the second would make a
  // stalled batch job look like a reporting finding.
  { key: 'Not categorised', color: '#d03b3b' },
]

export const COLOR_BY_FAMILY = new Map(FAMILIES.map((family) => [family.key, family.color]))
